export default {
  title: {
    changeMobileRequest: '更改手机帐号申请',
    bindMobileRequest: '绑定手机帐号申请'
  },
  label: {
    currentMobile: '当前手机帐号',
    newMobile: '新手机帐号',
    pleaseEnterMobile: '请输入您的大陆手机号',
    captcha: '图形验证码',
    smsCode: '手机验证码',
    generate: '获取验证码'
  },
  message: {
    mobileIsInvalid: '号码无效，非中国大陆号码暂不提供绑定服务。',
    success: '您已经成功绑定了手机号码，现在您可以使用手机号码登录了。'
  }
}
